import { render, staticRenderFns } from "./Import.vue?vue&type=template&id=7f80cc0d&"
import script from "./Import.vue?vue&type=script&lang=ts&"
export * from "./Import.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports